export const CCTP_UNIFIED_ASSETS = {
  "0x4343545055534443000000000000000000000000000000000000000000000000": 65537,
} as const;